export function Pagination({ total, page, pageSize, onPageChange }) {
  const pages = Math.max(1, Math.ceil(total / pageSize));
  const from = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const to = Math.min(total, page * pageSize);

  const goTo = (p) => {
    if (p === "prev") onPageChange(Math.max(1, page - 1));
    else if (p === "next") onPageChange(page + 1);
    else onPageChange(p);
  };

  return (
    <div className="pagination">
      <div>
        Affichage <strong>{from}–{to}</strong> sur <strong>{total}</strong>
      </div>
      <div className="pages">
        <button data-page="prev" data-testid="page-prev" disabled={page === 1} onClick={() => goTo("prev")}>
          <i className="fa-solid fa-chevron-left"></i>
        </button>
        {Array.from({ length: pages }, (_, i) => i + 1).map((i) => (
          <button
            key={i}
            className={i === page ? "active" : ""}
            data-page={i}
            data-testid={`page-${i}`}
            onClick={() => goTo(i)}
          >
            {i}
          </button>
        ))}
        <button data-page="next" data-testid="page-next" disabled={page === pages} onClick={() => goTo("next")}>
          <i className="fa-solid fa-chevron-right"></i>
        </button>
      </div>
    </div>
  );
}

export default Pagination;
